import { Outlet } from 'react-router-dom'
import { Tabs } from '@components/Tabs/Tabs'
import { RoutePaths } from '@interfaces/routePaths'
import { ReactNode, useEffect } from 'react'
import { useAppDispatch } from '@hooks/redux'
import {
  clearBreadcrumbs,
  setActionsButton,
  setActiveSection,
  setInviteButton,
} from '@redux/site/siteSlice'

export const Base = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Community'))
    dispatch(clearBreadcrumbs())
    dispatch(setInviteButton(true))
    dispatch(setActionsButton(true))
  })

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Members',
            path: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            label: 'Invites',
            path: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_INVITES}`,
          },
          {
            label: 'Pending',
            path: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_PENDING}`,
            unviewed: 3,
          },
          {
            label: 'Partners',
            path: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_PARTNERS}`,
          },
        ]}
      />
      {children}
    </>
  )
}
